// extracted by mini-css-extract-plugin
module.exports = {"previewContainer":"SlotPreview_previewContainer__3g-cV"};